<div class="sidebar-detail">
  <div class="sidebar-panel">
    <div class="sidebar-content">
      <div class="panel-title">
        Failed Login Details
        <button type="button" class="close-icon" aria-label="Close" (click)="onClose()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="detail-row">
        <div class="field-label">Activity Type</div>
        <div class="field-value">{{ activityType }}</div>
      </div>

      <div class="detail-row">
        <div class="field-label">User</div>
        <div class="field-value">{{ userName || entityNameValue || 'N/A' }}</div>
      </div>

      <div class="detail-row">
        <div class="field-label">IP Address</div>
        <div class="field-value">{{ failedLoginInfo.ipAddress || 'N/A' }}</div>
      </div>

      <div class="detail-row">
        <div class="field-label">Error Reason</div>
        <div class="field-value">{{ failedLoginInfo.errorReason || 'N/A' }}</div>
      </div>

      <div class="detail-row">
        <div class="field-label">Client ID</div>
        <div class="field-value">{{ failedLoginInfo.clientId || 'N/A' }}</div>
      </div>

      <div class="detail-row">
        <div class="field-label">Date</div>
        <div class="field-value">{{ activityDate || 'N/A' }}</div>
      </div>
    </div>
  </div>
</div>
